import React, {FC} from 'react';
import {RouteComponentProps,} from 'react-router-dom';
import Footer from '../../components/footer';
import Header from "../../components/header/Header";

interface IPrivateLayout extends RouteComponentProps<any> {
    header: boolean,
    footer: boolean,
    wrapperClassName: string,
    title: string,
    backLink: string,
    fetchSuccessUCode: any,
    filterButton?: string,
    menuButton: string,
}

const Index: FC<IPrivateLayout> = (
    {
        title, children, backLink, filterButton, header, wrapperClassName = '', footer
    }
) => {

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className={`${wrapperClassName}`}>
            <div className="content-wrapper">
                {header && <Header title={title} backLink={backLink} filterButton={filterButton}/>}
                {children}
            </div>
            {footer && <Footer />}
        </div>
    );
}
export default Index
